<script lang="ts">
  import Icon from "../../common/icons/Icon.svelte";
  import pageUrl from "../../../PageUrl";
</script>

<div class="page-wrapper">
  <div class="header">
    <a href={pageUrl.HOME}>
      <Icon icon="datadocs-logo-home" width="137px" height="28px" />
    </a>
  </div>

  <slot />
</div>

<style lang="postcss">
  .page-wrapper::before {
    @apply absolute top-0 left-0 right-0;
    content: "";
    height: 810px;
    z-index: -1;
    background: linear-gradient(
      180deg,
      rgba(59, 199, 255, 0.1) 0%,
      rgba(255, 255, 255, 0) 100%
    );
  }

  .header {
    @apply py-4 mx-auto;
    width: max-content;
  }
</style>
